import { ComponentProps } from "react";

export const WPTBLogo = (props: ComponentProps<"svg">) => {
  return (
    <svg
      {...props}
      viewBox="0 0 134 131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120.619 0.704712H13.8714C6.502 0.704712 0.527954 6.64798 0.527954 13.9794V117.225C0.527954 124.557 6.502 130.5 13.8714 130.5H120.619C127.988 130.5 133.962 124.557 133.962 117.225V13.9794C133.962 6.64798 127.988 0.704712 120.619 0.704712Z"
        fill="url(#wptb_logo_paint0_linear_7_1042)"
      />
      <path
        d="M106.489 28.0007H28.0248C26.8471 28.0007 25.8923 28.9506 25.8923 30.1223V44.4636C25.8923 45.6354 26.8471 46.5852 28.0248 46.5852H106.489C107.667 46.5852 108.621 45.6354 108.621 44.4636V30.1223C108.621 28.9506 107.667 28.0007 106.489 28.0007Z"
        fill="white"
      />
      <path
        d="M59.7869 56.3042H28.0249C26.8471 56.3042 25.8923 57.254 25.8923 58.4257V72.7671C25.8923 73.9388 26.8471 74.8887 28.0249 74.8887H59.7869C60.9647 74.8887 61.9195 73.9388 61.9195 72.7671V58.4257C61.9195 57.254 60.9647 56.3042 59.7869 56.3042Z"
        fill="white"
      />
      <path
        d="M106.489 56.3042H74.7267C73.549 56.3042 72.5942 57.254 72.5942 58.4257V72.7671C72.5942 73.9388 73.549 74.8887 74.7267 74.8887H106.489C107.667 74.8887 108.621 73.9388 108.621 72.7671V58.4257C108.621 57.254 107.667 56.3042 106.489 56.3042Z"
        fill="white"
      />
      <path
        d="M59.7631 84.6194H28.001C26.8233 84.6194 25.8685 85.5693 25.8685 86.741V101.082C25.8685 102.254 26.8233 103.204 28.001 103.204H59.7631C60.9409 103.204 61.8957 102.254 61.8957 101.082V86.741C61.8957 85.5693 60.9409 84.6194 59.7631 84.6194Z"
        fill="white"
      />
      <path
        d="M106.465 84.6194H74.7029C73.5251 84.6194 72.5703 85.5693 72.5703 86.741V101.082C72.5703 102.254 73.5251 103.204 74.7029 103.204H106.465C107.643 103.204 108.598 102.254 108.598 101.082V86.741C108.598 85.5693 107.643 84.6194 106.465 84.6194Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="wptb_logo_paint0_linear_7_1042"
          x1="124.538"
          y1="-5.75483"
          x2="45.6569"
          y2="93.515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29ABE2" />
          <stop offset="1" stopColor="#0071BC" />
        </linearGradient>
      </defs>
    </svg>
  );
};
